import axios from "axios"
import { AuthHeader } from "configs/auth.token"
import { get } from "helper/request"
import { store } from "helper/store"
import { PatientFolderActions } from "redux_constants/patientfolder.state.constant"
import { customQueryParamsSerializer } from "utils/query_params_utils"
import { getStateAwareUrl } from "utils/utils"


export const updateAllPatientFolders = (allPatientFolders = []) => ({
    type: PatientFolderActions.ALL_FOLDERS_UPDATE,
    allPatientFolders
})

export const updatePatientFolderPage = (page = 1) => ({
    type: PatientFolderActions.PAGE_UPDATE,
    page,
})

export const updatePatientFolderTotalPages = (totalPage = 1) => ({
    type: PatientFolderActions.TOTAL_PAGES_UPDATE,
    totalPage,
})

export const updatePatientFolderTotalCount = (totalCount = 0) =>({
    type: PatientFolderActions.TOTAL_COUNT_UPDATE,
    totalCount,
})

export const updatePatientFolderSearchParams = (searchParamsMap = {}) => ({
    type: PatientFolderActions.SEARCH_PARAMS_UPDATE,
    searchParamsMap,
})

export const clearPatientFolderSearchParams = () => ({
    type: PatientFolderActions.SEARCH_PARAMS_CLEAR,
})

export const updateAllFolderTags = (allTags) => ({
    type: PatientFolderActions.ALL_TAGS_UPDATE,
    allTags,
})

export const fetchAllPatientFolders = () => {
    const url = "/api/patient_folder/"
    const params = { ...(store.getState().patientfolderReducer.searchParamsMap || {}), "view": "list" }

    axios.get(getStateAwareUrl(url), {
        params,
        paramsSerializer: customQueryParamsSerializer,
        "headers": { "Authorization": AuthHeader() }
    })
        .then(res => res.data)
        .then(data => {
            store.dispatch(updatePatientFolderPage(data?.page_number))
            store.dispatch(updatePatientFolderTotalPages(data?.total_pages))
            store.dispatch(updatePatientFolderTotalCount(data?.count))
            store.dispatch(updateAllPatientFolders(data?.results))
        })
        .catch(err => console.error(err.message))
}

export const fetchAllFolderTags = () => {
    const url = "/api/patient_folder_tag/"

    get(url)
        .then(data => {
            store.dispatch(updateAllFolderTags(data.map(({ name }) => name)))
        })
        .catch(err => console.error(err.message))
}